/**
 * Calls the API to extract text from a PDF (for guideline / instruction editors).
 */
import { apiUrl } from "@/lib/api-config";
export interface ExtractPdfMetadata {
  pageCount: number;
  wordCount: number;
}

export interface ExtractPdfResponse {
  text: string;
  metadata: ExtractPdfMetadata;
}

function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

export async function postExtractPdfText(
  file: File,
  getAccessToken: () => Promise<string | null>
): Promise<ExtractPdfResponse> {
  const token = await getAccessToken();
  if (!token) throw new Error("Not authenticated");

  const fileBase64 = await readFileAsDataUrl(file);

  const res = await fetch(apiUrl("/api/extract-pdf-text"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ fileBase64, fileName: file.name }),
  });

  const body = (await res.json().catch(() => ({}))) as { error?: string; text?: string; metadata?: ExtractPdfMetadata };

  if (!res.ok) {
    throw new Error(body.error || `Extraction failed (${res.status})`);
  }

  if (typeof body.text !== "string" || !body.metadata) {
    throw new Error("Invalid extract response");
  }

  return { text: body.text, metadata: body.metadata };
}
